export const historicalFulfillmentTime = {
    name: "HistoricalFulfillmentTime",
    variants: [
        ["Control", 1],
        ["Test", 1],
    ],
    controlVariant: "Control",
    apply: ({ assignVariant, clearVariant, isParticipatingInOtherTests }) => {
        if (Skubacz.configuration.environment === "systemtest") {
            return;
        }
        const isInOtherTest = isParticipatingInOtherTests();
        // Sites excluded due to unreliable fulfillment time data.
        const blockedSiteIds = [356906, 32075];
        const isBlockedSite = blockedSiteIds.includes(Skubacz.configuration.site_id);
        if (!isInOtherTest && !isBlockedSite) {
            assignVariant();
        }
        else {
            clearVariant();
        }
    },
};
